'use client';
import React from 'react';

export default function SupportButton() {
  return (
    <button
      type="button"
      className="support-launcher"
      aria-label="Open support"
      aria-expanded="false"
      style={{'--support-lift':'0px'} as React.CSSProperties}
    >
      <span style={{transition:'transform .24s var(--ease-out)',placeItems:'center',display:'grid'}}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <path d="M20.5 11.6c0 4-3.8 7.2-8.5 7.2a9.7 9.7 0 0 1-2.6-.35L4.6 20.2l1.2-3.4A6.9 6.9 0 0 1 3.5 11.6c0-4 3.8-7.2 8.5-7.2s8.5 3.2 8.5 7.2Z" strokeLinejoin="round"/>
        </svg>
      </span>
    </button>
  );
}
